export const PAYOUT_ONLY_ADMIN_ID = "as87sdh";

export function isPayoutOnlyAdmin(adminData) {
  return adminData?.admin_id === PAYOUT_ONLY_ADMIN_ID;
}

export function isPathAllowedForPayoutOnlyAdmin(pathname) {
  const path = String(pathname || "");
  if (path === "/payoutListAdmin") return true;
  if (path === "/login" || path.startsWith("/login/")) return true;
  if (path.startsWith("/payout/")) return true;
  return false;
}
